export default __webpack_public_path__ + "static/fitness-externo-53dee573049eba8776d4a95bf9f24e39.jpg";